export default {
    prePayInfo: "/gateway/huilian/receipts/selectReceiptsPrePay",
    payCreate: "/gateway/huilian/receipts/receiptsAgentPay",
};



// WEBPACK FOOTER //
// ./src/pages/collectionOnline/api.js